module.exports = __webpack_public_path__ + "static/media/madame.932b02b3.png";